<template>
    <v-container v-if="loading">
        <v-row>
            <v-col cols="12" class="text-center">
                <v-progress-circular
                    indeterminate
                    color="primary"
                ></v-progress-circular>
            </v-col>
        </v-row>
    </v-container>
    <v-container v-else>
        <v-row v-if="error">
            <v-col cols="12">  
                <v-alert type="error" dismissible>
                    {{ error }}
                </v-alert>              
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-form  @submit.prevent="handleSubmit">
                    <v-container>
                        <!-- Select client -->
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-select
                                    :label="$t('psychologistNewEvaluation.client')"
                                    :items="formatedClients"
                                    item-title="displayText"
                                    item-value="id"
                                    v-model="selectedClient"
                                >
                                </v-select>
                            </v-col>
                        </v-row>

                        <!-- Select scales -->
                        <v-row v-for="(scale, idx) in addedScales" >
                            <v-col cols="8" md="3">
                                <v-select
                                    :label="$t('psychologistNewEvaluation.scale')"
                                    :items="availableScales"
                                    item-title="name"
                                    item-value="scale_id"
                                    v-model="addedScales[idx].scale_id"
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="4" md="1">
                                <v-btn @click="removeScale(idx)">-</v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-btn @click="addScale">{{ $t('psychologistNewEvaluation.add_scale') }}</v-btn>
                            </v-col>
                        </v-row>

                        <!-- Other options -->
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-select
                                    :label="$t('psychologistNewEvaluation.expiring_interval')"
                                    :items="translatedExpiringIntervals"
                                    item-title="interval"
                                    item-value="no_of_days"
                                    v-model="selectedExpiringInterval"
                                </v-select>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="4">
                                <v-checkbox
                                :label="$t('psychologistNewEvaluation.requires_login')"
                                v-model="requiresLogin"
                                :hint="$t('psychologistNewEvaluation.requires_login_hint')"
                                persistent-hint
                                :readonly="true"
                            />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-checkbox
                                :label="$t('psychologistNewEvaluation.all_scales_in_a_single_page')"
                                v-model="singlePage"
                                :hint="$t('psychologistNewEvaluation.all_scales_in_a_single_page_hint')"
                                persistent-hint
                                :readonly="true"
                            />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-checkbox
                                    :label="$t('psychologistNewEvaluation.bind_to_device')"
                                    :hint="$t('psychologistNewEvaluation.bind_to_device_hint')"
                                    persistent-hint
                                    v-model="bindToDevice"
                                    :readonly="true"
                                />
                            </v-col>
                        </v-row>

                        <!-- Submit button -->
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-btn class="mt-2" type="submit" block>{{ $t('psychologistNewEvaluation.create') }}</v-btn>
                            </v-col>
                        </v-row>
                        
                    </v-container>
                </v-form>
            </v-col>
        </v-row>
    </v-container>

</template>

<script>
import apiService from '@/services/ApiService'
import EvaluationView from '../client/EvaluationView.vue';

export default {
    name: 'PsychologistNewEvaluationView',
    data(){
        return {
            loading: false,
            error: null,
            clients: [],
            selectedClient: "",
            availableScales: [],
            addedScales: [],
            singlePage: true,
            bindToDevice: true,
            requiresLogin: false,
            expiring_intervals: [
                {key: '1_day', no_of_days: 1},
                {key: '3_days', no_of_days: 3},
                {key: '7_days_1_week', no_of_days: 7},
                {key: '14_days_2_weeks', no_of_days: 14},
            ],
            selectedExpiringInterval: 7,
        }
    },

    methods: {
        validate(){
            let uniqueScaleIds = new Set(this.addedScales.map(s => s.scale_id))
            if(uniqueScaleIds.size != this.addedScales.length){
                this.$toast.error(this.$t('psychologistNewEvaluation.you_have_selected_the_same_scale_more_than_once'))
                this.error = this.$t('psychologistNewEvaluation.you_have_selected_the_same_scale_more_than_once'); //this is reset by the watcher
                return false;
            }
            return true;
        },

        async handleSubmit() {
            // Your form handling logic here
            console.log('Form submitted without page refresh');
            // console.log("Scales=[" + this.addedScales.reduce((acc, curv) => acc + curv.id + ',', '') + "] Single page=" + this.singlePage);

            if(this.validate()){
                console.log('Form is valid');

                console.log(`Store > Is logged in: ${this.store.isLoggedIn}`)
                console.log(`Store > user: ${this.store.user}`)                
                console.log(`Evaluation[ selectedClient: ${this.selectedClient} ]`)
                const evaluationData = {
                    psychologist_id: this.store.user.user_id,
                    client_id: this.selectedClient,
                    scalesIds: this.addedScales.map(scale => scale.scale_id),
                    expiringInterval : this.selectedExpiringInterval
                }                

                let evaluationId = 'The-evaluation-id-from-back-end';
                let token = 'The-evaluation-token-from-back-end';

                try{
                    const evaluation = await apiService.createEvaluation(evaluationData)
                    console.log('PsychologistNewEvaluationView > Response create evaluation:', evaluation);
                    evaluationId = evaluation.evaluation_id;
                    token = evaluation.token;
                } catch(error){
                    console.error('Error creating evaluation:', error);
                }
                

                // Navigate with parameters
                this.$router.push({ 
                    path: `/psychologist/viewEvaluation/${token}`, 
                })
            }
            else{
                console.log('Form is NOT valid');
            }
        },

        addScale(){
            console.log('Add Scale clicked');

            //compute which scales are left to (potential) add
            let leftScales = this.availableScales.filter(availScale =>
                !this.addedScales.some(addedScale => addedScale.scale_id === availScale.scale_id)
            );
            if(leftScales.length == 0){
                this.$toast.error(this.$t('psychologistNewEvaluation.no_more_scales_to_add'))
                console.log('No more scales to add');
                return;
            }

            //pick the first available scale
            let firstAvailableScale = leftScales[0];

            this.addedScales.push({
                ...firstAvailableScale //make a brand new copy of the retrieved scale
            })
        },

        removeScale(index){
            this.addedScales.splice(index, 1)
        },

        /**
         * Get only scales available that were not grabbed by previous selects 
        */
        filteredAvailableScales(idx){
            console.log('filteredAvailableScales called for idx=', idx);

            //find what scales were already added in previous selects
            let previouslyAddedScales = this.addedScales.slice(0, idx);

            //return only scales that are not already added
            return this.availableScales.filter(availScale => 
                !previouslyAddedScales.some( (addedScale,i) => addedScale.scale_id === availScale.scale_id)
            );
        }
    },

    async created() {
        console.log('NODE_ENV:', process.env.NODE_ENV);
        console.log('All process.env:', process.env);
        console.log('VUE_APP_API_ENDPOINT:', process.env.VUE_APP_API_ENDPOINT);        
        // const apiUrl = 'http://localhost:7070/api'; // Adjust the API endpoint as needed
        // You can perform any asynchronous operations here if needed
        console.log('PsychologistNewEvaluationView created');
        try {
            this.loading = true;
            const [clients, scales] = await Promise.all([
                apiService.getClientsForPsychologist(),
                apiService.getScales(this.$i18n.locale)
            ]);

            // let clients = await apiService.getClientsForPsychologist()
            console.log('Response clients:', clients);
            console.log('Response scales:', scales);

            this.clients = clients;
            this.availableScales = scales;
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            this.loading = false;
        }

        const clientIdFromQuery = this.$route.query.clientId;
        if(clientIdFromQuery){
            console.log('PsychologistNewEvaluationView > mounted > clientId = ', this.$route.query.clientId)
            const foundClient = this.formatedClients.find(c => c.id == parseInt(clientIdFromQuery))
            if(foundClient){
                this.selectedClient = foundClient.id
            }
        }
    },

    computed: {
        formatedClients(){
            return this.clients.map(client => ({
                id: client.user_id,
                displayText: `${client.firstName} (${client.lastName})`,
                // Include only the properties you need
                email: client.email
            }));
        },
        translatedExpiringIntervals(){
            return this.expiring_intervals.map(interval => ({
                interval: this.$t(`psychologistNewEvaluation.${interval.key}`),
                no_of_days: interval.no_of_days
            }));
        },
    }, //end computed

    watch:{
        addedScales: {
            handler(newVal){
                this.error = null;
                console.log('Selected scales changed:', newVal);
            },
            deep: true
        },
    }
}
</script>

<style scoped>
</style>